import script from "./Access.vue?vue&type=script&lang=ts&setup=true"
export * from "./Access.vue?vue&type=script&lang=ts&setup=true"

import "./Access.vue?vue&type=style&index=0&id=31309973&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31309973"]])

export default __exports__